import { Injectable } from "@angular/core";
import { OrderService } from "../../../services/orderService";
import { SearchResponse } from "../../../objects/responses/searchResponse";
import { Order } from "../../../objects/orders/order";
import { OrderSearchRequest } from "../../../objects/requests/orderSearchRequest";
import { ActivatedRouteSnapshot } from "@angular/router";
import { CustomerService } from "../../../services/customerService";
import { UserService } from "../../../services/userService";
import { CalculatorHelper } from "../../../common/helpers/calculatorHelper";
import { UserViewService } from "../../../services/userViewService";
import { OrderBy } from "ngx-odata-v4";
import { OrderODataService } from "../../../services/orderOData.service";
import { Component } from "../../../objects/components/component";
import { Column, SortType } from "../../../objects/users/user";
import { OrderViewType } from "../../../objects/management/order/orderViewType";
import { ScreenHelper } from "../../../common/helpers/screenHelper";
import { UserViewHelper } from "../../../common/helpers/userViewHelper";

/**
 * Created by alex.y on 9/13/2017.
 */


@Injectable()
export class OrderManagementResolver {

    constructor(private orderService: OrderService,
                private customerService: CustomerService,
                private userService: UserService,
                private userViewService: UserViewService,
                private orderODataService: OrderODataService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<SearchResponse<Order>> {

        let currentConfigs = this.userViewService.userView[Component.OrderManagement];

        const isOrderManagement = route.routeConfig.path == 'management/order';
        let top = (currentConfigs.ViewType == OrderViewType.Table) && isOrderManagement ? 20 : 12;

        if(ScreenHelper.isPhone()){
            currentConfigs.ViewType = OrderViewType.Tile;
        }

        let orderBy: any = UserViewHelper.getColumnOrderBy(this.userViewService.userView, Component.OrderManagement);

        let customerId = route.params["customerid"];
        let query = CalculatorHelper.replaceOrderPrefix(route.params['query']);
        let agentId = route.params['agentid'];

        if (agentId)
            return this.orderODataService.getOrdersByAgentId(agentId, 0, top, orderBy).then(result => {
                return result;
            }).catch(err => {
                return null;
            });

        if (customerId)
            return this.orderODataService.getByCustomerId(customerId, 0, top).then(result => {
                return result;
            }).catch(err => {
                return null;
            });

        return this.orderService.search(new OrderSearchRequest({
            Skip: 0,
            Top: top,
            Query: query ? query : "",
            OrderBy: orderBy
        })).then(result => {
            return result;
        }).catch(err => {
            return null;
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderManagement.resolver.ts